<div mat-dialog-title class="dialog-header">
  <span>Configure {{chargepoint.id}}</span>
  <div class="spacer"></div>
  <button mat-icon-button (click)="close()" color="secondary">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @switch (chargepoint.type) {
    @case ('OCPP') {
      <app-chargepoint-configuration-ocpp [chargepoint]="$any(chargepoint)"></app-chargepoint-configuration-ocpp>
    }
    @case ('OKECHARGE') {
      <p>OkeCharge Configuration not implemented yet</p>
    }
    @case ('IVY') {
      <p>Ivy Configuration not implemented yet</p>
    }
    @default {
      <p>Unknown chargepoint type</p>
    }
  }
</mat-dialog-content>
